// extracted by mini-css-extract-plugin
var _1 = "ValidationSummary-module__validationSummary--PjQmK";
export { _1 as "validationSummary" }
